// Exportar el reporte de ventas a PDF (impresión) y Excel (TSV con BOM).
// Movido tal cual desde la página de Reportes anterior.
import { descargarBlob } from '../../utils/descargar';

function fmt(n: any) {
  return parseFloat(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
// 'deposito'/'retiro' es como lo guarda la base; en pantalla se lee mejor entró/salió.
export function tipoMovLabel(tipo: string) {
  if (tipo === 'deposito') return 'Entró';
  if (tipo === 'comision_propina') return 'Comisión';
  return 'Salió';
}

/* ── Exportar PDF ── */
export function exportarPDF(datos: any, fechaInicio: string, fechaFin: string, catLabel: (c?: string) => string) {
  const r = datos.resumen;
  const filasProductos = datos.top_productos.map((p: any, i: number) => `
    <tr>
      <td>${i + 1}</td><td>${p.producto}</td><td>${p.categoria}</td>
      <td style="text-align:center">${p.unidades}</td>
      <td style="text-align:right">$${fmt(p.total_vendido)}</td>
      <td style="text-align:right">$${fmt(p.costo_total)}</td>
      <td style="text-align:right">$${fmt(parseFloat(p.total_vendido) - parseFloat(p.costo_total || 0))}</td>
    </tr>`).join('');

  const filasDia = datos.por_dia.map((d: any) => `
    <tr>
      <td>${d.fecha}</td>
      <td style="text-align:center">${d.comandas}</td>
      <td style="text-align:right">$${fmt(d.ventas)}</td>
      <td style="text-align:right">$${fmt(d.propinas)}</td>
      <td style="text-align:right">$${fmt(parseFloat(d.ventas) + parseFloat(d.propinas))}</td>
    </tr>`).join('');

  const filasMov = (datos.movimientos?.por_categoria || []).map((m: any) => `
    <tr>
      <td>${catLabel(m.categoria)}</td>
      <td>${tipoMovLabel(m.tipo)}</td>
      <td style="text-align:center">${m.cantidad}</td>
      <td style="text-align:right">$${fmt(m.total)}</td>
    </tr>`).join('');

  const html = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8">
  <title>Reporte de Ventas ${fechaInicio} al ${fechaFin}</title>
  <style>
    body { font-family: Arial, sans-serif; font-size: 11px; color: #000; margin: 20px; }
    /* Color literal: las variables CSS del panel no existen dentro del
       iframe aislado donde se imprime este documento. */
    h1 { font-size: 18px; color: #B91C1C; margin-bottom: 4px; }
    h2 { font-size: 13px; color: #333; margin: 16px 0 8px; border-bottom: 1px solid #ccc; padding-bottom: 4px; }
    .periodo { font-size: 11px; color: #666; margin-bottom: 16px; }
    .resumen { display: grid; grid-template-columns: repeat(6,1fr); gap: 12px; margin-bottom: 16px; }
    .card { border: 1px solid #ddd; border-radius: 8px; padding: 10px; }
    .card-label { font-size: 10px; color: #888; }
    .card-value { font-size: 16px; font-weight: bold; color: #B91C1C; margin-top: 2px; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
    th { background: #f5f5f5; text-align: left; padding: 5px 8px; font-size: 10px; text-transform: uppercase; }
    td { padding: 4px 8px; border-bottom: 1px solid #f0f0f0; }
    @media print { @page { margin: 12mm; } }
  </style></head><body>
  <h1>Reporte de Ventas — CHARGOY</h1>
  <p class="periodo">Período: ${fechaInicio} al ${fechaFin}</p>
  <div class="resumen">
    <div class="card"><div class="card-label">Total ventas</div><div class="card-value">$${fmt(r.total_ventas)}</div></div>
    <div class="card"><div class="card-label">Comandas</div><div class="card-value">${r.total_comandas}</div></div>
    <div class="card"><div class="card-label">Ticket promedio</div><div class="card-value">$${fmt(r.ticket_promedio)}</div></div>
    <div class="card"><div class="card-label">Propinas</div><div class="card-value">$${fmt(r.total_propinas)}</div></div>
    <div class="card"><div class="card-label">Costo total</div><div class="card-value">$${fmt(r.total_costo)}</div></div>
    <div class="card"><div class="card-label">Utilidad</div><div class="card-value">$${fmt(r.utilidad)}</div></div>
  </div>
  <h2>Ventas por día</h2>
  <table><thead><tr><th>Fecha</th><th>Comandas</th><th>Ventas</th><th>Propinas</th><th>Total</th></tr></thead>
  <tbody>${filasDia}</tbody></table>
  <h2>Movimientos de caja</h2>
  <table><thead><tr><th>Concepto</th><th>Entró / Salió</th><th>Movimientos</th><th>Total</th></tr></thead>
  <tbody>${filasMov}</tbody></table>
  <h2>Productos por menor venta</h2>
  <table><thead><tr><th>#</th><th>Producto</th><th>Categoría</th><th>Unidades</th><th>Total vendido</th><th>Costo</th><th>Utilidad</th></tr></thead>
  <tbody>${filasProductos}</tbody></table>
  <script>window.onload=()=>{window.print();window.onafterprint=()=>window.close();}</script>
  </body></html>`;

  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:0';
  document.body.appendChild(iframe);
  const doc = iframe.contentDocument!;
  doc.open(); doc.write(html); doc.close();
  setTimeout(() => {
    iframe.contentWindow!.focus();
    iframe.contentWindow!.print();
    setTimeout(() => { try { document.body.removeChild(iframe); } catch {} }, 3000);
  }, 300);
}

/* ── Exportar Excel (CSV multi-sección) ── */
export function exportarExcel(datos: any, fechaInicio: string, fechaFin: string, metodoLabel: (c: string) => string, catLabel: (c?: string) => string) {
  const r = datos.resumen;

  const secciones = [
    ['REPORTE DE VENTAS CHARGOY'],
    [`Período: ${fechaInicio} al ${fechaFin}`],
    [],
    ['RESUMEN GENERAL'],
    ['Total ventas', `$${fmt(r.total_ventas)}`],
    ['Total comandas', r.total_comandas],
    ['Ticket promedio', `$${fmt(r.ticket_promedio)}`],
    ['Total propinas', `$${fmt(r.total_propinas)}`],
    ['Total descuentos', `$${fmt(r.total_descuentos)}`],
    ['Costo total', `$${fmt(r.total_costo)}`],
    ['Utilidad', `$${fmt(r.utilidad)}`],
    [],
    ['VENTAS POR DÍA'],
    ['Fecha', 'Comandas', 'Ventas', 'Propinas', 'Total'],
    ...datos.por_dia.map((d: any) => [
      d.fecha, d.comandas, fmt(d.ventas), fmt(d.propinas),
      fmt(parseFloat(d.ventas) + parseFloat(d.propinas)),
    ]),
    [],
    ['VENTAS POR MÉTODO DE PAGO'],
    ['Método', 'Comandas', 'Total', 'Propinas'],
    ...datos.por_metodo.map((m: any) => [
      metodoLabel(m.metodo), m.comandas, fmt(m.total), fmt(m.propinas),
    ]),
    [],
    ['MOVIMIENTOS DE CAJA'],
    ['Concepto', 'Entró / Salió', 'Movimientos', 'Total'],
    ...(datos.movimientos?.por_categoria || []).map((m: any) => [
      catLabel(m.categoria), tipoMovLabel(m.tipo), m.cantidad, fmt(m.total),
    ]),
    [],
    ['DETALLE DE MOVIMIENTOS DE CAJA'],
    ['Fecha', 'Concepto', 'Motivo', 'Entró / Salió', 'Monto', 'Registró'],
    ...(datos.movimientos?.detalle || []).map((d: any) => [
      new Date(d.created_at).toLocaleString('es-MX'), catLabel(d.categoria),
      d.mesero ? `${d.motivo} · ${d.mesero}` : d.motivo,
      tipoMovLabel(d.tipo), fmt(d.monto), d.usuario,
    ]),
    [],
    ['PRODUCTOS POR MENOR VENTA'],
    ['#', 'Producto', 'Categoría', 'Unidades', 'Total vendido', 'Costo', 'Utilidad'],
    ...datos.top_productos.map((p: any, i: number) => [
      i + 1, p.producto, p.categoria, p.unidades, fmt(p.total_vendido),
      fmt(p.costo_total), fmt(parseFloat(p.total_vendido) - parseFloat(p.costo_total || 0)),
    ]),
  ];

  const csv = secciones.map(r => r.join('\t')).join('\n');
  const bom = '﻿'; // BOM para Excel en español
  const blob = new Blob([bom + csv], { type: 'text/tab-separated-values;charset=utf-8' });
  descargarBlob(blob, `reporte-ventas-${fechaInicio}-${fechaFin}.xls`);
}
